import { render, staticRenderFns } from "./KlasusLevel2.vue?vue&type=template&id=1b670e68&scoped=true"
import script from "./KlasusLevel2.vue?vue&type=script&lang=js"
export * from "./KlasusLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b670e68",
  null
  
)

export default component.exports